import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Receipt, Bank, Heart } from "@phosphor-icons/react";
import { ExpenseClaims } from "./ExpenseClaims";
import { Payslips } from "./Payslips";
import { BenefitsEnrollment } from "./BenefitsEnrollment";

export function PayrollDashboard() {
  const [activeTab, setActiveTab] = useState("expenses");

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="flex flex-col gap-2">
        <h2 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-slate-900 to-slate-700 dark:from-white dark:to-slate-300">
          Payroll & Finance
        </h2>
        <p className="text-slate-500 dark:text-slate-400">
          Manage expenses, view payslips, and enroll in benefits.
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-3 lg:w-auto">
          <TabsTrigger value="expenses" className="gap-2">
            <Receipt className="w-4 h-4" />
            <span className="hidden md:inline">Expenses</span>
          </TabsTrigger>
          <TabsTrigger value="payslips" className="gap-2">
            <Bank className="w-4 h-4" />
            <span className="hidden md:inline">Payslips</span>
          </TabsTrigger>
          <TabsTrigger value="benefits" className="gap-2">
            <Heart className="w-4 h-4" />
            <span className="hidden md:inline">Benefits</span>
          </TabsTrigger>
        </TabsList>

        <div className="mt-6">
          <TabsContent value="expenses" className="space-y-4">
            <ExpenseClaims />
          </TabsContent>

          <TabsContent value="payslips" className="space-y-4">
            <Payslips />
          </TabsContent>

          <TabsContent value="benefits" className="space-y-4">
            <BenefitsEnrollment />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
}
